import { render } from "./AjoutCommentaires.vue?vue&type=template&id=70bb8a14"
import script from "./AjoutCommentaires.vue?vue&type=script&lang=js"
export * from "./AjoutCommentaires.vue?vue&type=script&lang=js"

import "./AjoutCommentaires.vue?vue&type=style&index=0&id=70bb8a14&lang=scss"

import exportComponent from "/Users/anthony/Documents/APP/SIMEF LAST/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__